__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "yepic-chat";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@daily-co/daily-js", "0.71.2", () => (__webpack_require__.e(414).then(() => (() => (__webpack_require__(30414))))));
			register("@daily-co/daily-react", "0.20.0", () => (__webpack_require__.e(54).then(() => (() => (__webpack_require__(2673))))));
			register("@headlessui/react", "2.1.1", () => (__webpack_require__.e(72).then(() => (() => (__webpack_require__(53072))))));
			register("@livekit/components-core", "0.10.5", () => (__webpack_require__.e(293).then(() => (() => (__webpack_require__(41293))))));
			register("@livekit/components-react", "2.3.5", () => (__webpack_require__.e(901).then(() => (() => (__webpack_require__(15901))))));
			register("@radix-ui/react-popover", "1.1.6", () => (__webpack_require__.e(503).then(() => (() => (__webpack_require__(75503))))));
			register("@sentry/react", "7.120.3", () => (__webpack_require__.e(130).then(() => (() => (__webpack_require__(14749))))));
			register("@sentry/tracing", "7.120.3", () => (__webpack_require__.e(613).then(() => (() => (__webpack_require__(83613))))));
			register("@tanstack/react-table", "8.20.6", () => (__webpack_require__.e(972).then(() => (() => (__webpack_require__(99972))))));
			register("async-mutex", "0.4.1", () => (__webpack_require__.e(976).then(() => (() => (__webpack_require__(78976))))));
			register("axios", "1.7.2", () => (__webpack_require__.e(344).then(() => (() => (__webpack_require__(24344))))));
			register("date-fns", "4.1.0", () => (__webpack_require__.e(449).then(() => (() => (__webpack_require__(5449))))));
			register("formik", "2.4.6", () => (__webpack_require__.e(516).then(() => (() => (__webpack_require__(63516))))));
			register("hls.js", "1.5.20", () => (__webpack_require__.e(788).then(() => (() => (__webpack_require__(49788))))));
			register("iconsax-reactjs", "0.0.8", () => (__webpack_require__.e(810).then(() => (() => (__webpack_require__(61810))))));
			register("livekit-client", "2.3.1", () => (__webpack_require__.e(192).then(() => (() => (__webpack_require__(93192))))));
			register("lottie-react", "2.4.0", () => (__webpack_require__.e(750).then(() => (() => (__webpack_require__(93750))))));
			register("microsoft-cognitiveservices-speech-sdk", "1.38.0", () => (__webpack_require__.e(685).then(() => (() => (__webpack_require__(38685))))));
			register("react-colorful", "5.6.1", () => (__webpack_require__.e(497).then(() => (() => (__webpack_require__(74497))))));
			register("react-datepicker", "8.2.0", () => (__webpack_require__.e(261).then(() => (() => (__webpack_require__(26261))))));
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(97950))), 1);
			register("react-intersection-observer", "9.13.1", () => (__webpack_require__.e(843).then(() => (() => (__webpack_require__(35843))))));
			register("react-router", "6.10.0", () => (__webpack_require__.e(216).then(() => (() => (__webpack_require__(73216))))));
			register("react-toastify", "10.0.5", () => (__webpack_require__.e(36).then(() => (() => (__webpack_require__(91036))))));
			register("react", "18.3.1", () => (() => (__webpack_require__(65043))), 1);
			register("recoil", "0.7.7", () => (__webpack_require__.e(831).then(() => (() => (__webpack_require__(60831))))));
			register("store", "2.0.12", () => (__webpack_require__.e(366).then(() => (() => (__webpack_require__(13366))))));
			register("tailwind-merge", "2.3.0", () => (__webpack_require__.e(359).then(() => (() => (__webpack_require__(89359))))));
			register("usehooks-ts", "3.1.0", () => (__webpack_require__.e(483).then(() => (() => (__webpack_require__(54483))))));
			register("uuid", "9.0.1", () => (__webpack_require__.e(355).then(() => (() => (__webpack_require__(28355))))));
			register("yup", "1.4.0", () => (__webpack_require__.e(899).then(() => (() => (__webpack_require__(80899))))));
			register("zustand-middleware-computed-state", "0.1.3", () => (__webpack_require__.e(816).then(() => (() => (__webpack_require__(15054))))));
			register("zustand", "4.5.4", () => (__webpack_require__.e(548).then(() => (() => (__webpack_require__(4548))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};